import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ReadOrderDto } from '../generated-dto';
import { OrderExposeGroup } from '../interface';
export class ListOrderV2Dto {
}
__decorate([
    ApiProperty({ type: () => Object, description: 'Pagination details' }),
    Expose({ groups: [OrderExposeGroup.READ] }),
    __metadata("design:type", Object)
], ListOrderV2Dto.prototype, "pagination", void 0);
__decorate([
    Type(() => ReadOrderDto),
    ApiProperty({ type: () => ReadOrderDto, isArray: true, description: 'Rows matched' }),
    Expose({ groups: [OrderExposeGroup.READ] }),
    __metadata("design:type", Array)
], ListOrderV2Dto.prototype, "rows", void 0);
//# sourceMappingURL=ListOrderV2Dto.js.map